import Register from "views/examples/Register.js";
import Login from "views/examples/Login.js";

import Solicitudes from "views/examples/Solicitudes";
import Cookies from "universal-cookie";

import SolicitudesPropias from "views/examples/SolicitudesPropias";
import ConsultarGlpi from "views/GLPI/ConsultarGlpi";

const cookie = new Cookies();
const tipoUsuario = cookie.get("tipo_Usuario");
const correo = cookie.get("correo");

const routesLegal = [
  // Mostrar Solicitudes propias si NO es tipo 5
  tipoUsuario != 5
    ? {
        path: "/Solicitudes/" + correo,
        name: "Solicitudes",
        icon: "ni ni-bullet-list-67 text-blue",
        component: <SolicitudesPropias />,
        layout: "/admin",
      }
    : null,

  // Mostrar Solicitudes asignadas si es tipo 5
  tipoUsuario == 5
    ? {
        path: "/SolicitudesAsignadas/" + correo,
        name: "Solicitudes Asignadas",
        icon: "ni ni-bullet-list-67 text-blue",
        component: <Solicitudes />,
        layout: "/admin",
      }
    : null,

  {
    path: "/login",
    component: <Login />,
    layout: "/auth",
  },
  {
    path: "/register",
    component: <Register />,
    layout: "/auth",
  },
].filter(Boolean); // Elimina nulls del array

export default routesLegal;
